import React from 'react';
import {
  shape, number, bool, string, func, arrayOf, object
} from 'prop-types';
import classNames from 'classnames';
import { Typography } from '@one-thd/sui-atomic-components';
import VisualTabs from './VisualTabs';

const CollectionsTitle = (props) => {
  const {
    metadata,
    productIdentifier,
    isMobile,
    isCategoryTab,
    colSpanClasses,
    recsCollectionTabCount,
    categories,
    pullFilteredData,
    products,
    showColUpLevel
  } = props;

  const titleClasses = classNames('sui-grid', 'sui-grid-cols-1', { 'sui-pt-8': !isMobile && showColUpLevel },
    { 'sm:sui-grid-cols-3 sui-gap-4': (metadata?.collectionImageUrl && !showColUpLevel) });

  const productBrandName = productIdentifier?.brandName;

  return (
    <div className={titleClasses}>
      <div>
        {metadata?.collectionTitle1 ? (
          <div className="sui-pb-2 sm:sui-pb-0">
            <Typography variant="h2">{metadata?.collectionTitle1}</Typography>
          </div>
        ) : (
          <div className="sui-pb-2 sm:sui-pb-0">
            <Typography variant="h2">{productBrandName}</Typography>
          </div>
        )}

        {metadata?.collectionTitle2 && (
          <div className="sui-pb-2 sm:sui-pb-0">
            <Typography variant="body-base" weight="bold" component="h3">{metadata?.collectionTitle2}</Typography>
          </div>
        )}
      </div>
      {showColUpLevel ? <div className="sui-pt-4"> Find items that go well together </div> : ''}
      {!isMobile && isCategoryTab && (
        <div className={colSpanClasses}>
          {isCategoryTab && categories?.length > 0 && categories?.length >= recsCollectionTabCount && (
            // eslint-disable-next-line max-len
            <VisualTabs products={products} categories={categories} filterItemIds={pullFilteredData} />
          )}
        </div>
      )}
    </div>
  );
};

CollectionsTitle.propTypes = {
  metadata: shape({
  }),
  productIdentifier: shape({
  }),
  isMobile: bool,
  recsCollectionTabCount: number,
  isCategoryTab: bool,
  showColUpLevel: bool,
  categories: arrayOf(Object),
  products: arrayOf(Object),
  pullFilteredData: func,
  colSpanClasses: string
};

CollectionsTitle.defaultProps = {
  metadata: {},
  productIdentifier: {},
  isMobile: false,
  recsCollectionTabCount: 4,
  isCategoryTab: false,
  showColUpLevel: false,
  categories: null,
  products: null,
  pullFilteredData: () => { },
  colSpanClasses: null
};

export default CollectionsTitle;